import {
  GET_ORGANIZATION,
  GET_KNOWLEDGE,
  GET_IMPACT,
  GET_GOAL,
  GET_KNOWLEDGE_MAP,
  GET_KNOWLEDGE_COUNT,
  GET_KNOWLEDGE_CHART,
  GET_KNOWLEDGE_RESULT,
  GET_NEWKNOWLEDGE_RESULT,
  GET_INNOVATIONS_RESULT,
  GET_RESULT_ONE,
  GET_GOAL_MAP,
  GET_GOAL_CHART,
  GET_GOAL_COUNT,
  GET_BCG_RESULT,
  GET_SDGS_RESULT,
  GET_CURVE_RESULT,
  GET_CLUSTER_RESULT,
  GET_IMPACT_MAP,
  GET_IMPACT_COUNT,
  GET_IMPACT_CHART,
  GET_ECONOMY_RESULT,
  GET_SOCIETY_RESULT,
  GET_CULTURE_RESULT,
  GET_ENVIRONMENT_RESULT,
  GET_NEWKNOWLEDGE_MAP,
  GET_NEWKNOWLEDGE_COUNT,
  GET_NEWKNOWLEDGE_CHART,
} from "../types";

import ApiData from "../api";
export const getorganization = () => async (dispatch) => {
  try {
    const res = await ApiData.getorganization();
    dispatch({
      type: GET_ORGANIZATION,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
};
export const getknowledge = () => async (dispatch) => {
  try {
    const res = await ApiData.getknowledge();
    dispatch({
      type: GET_KNOWLEDGE,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
};
export const getimpact = () => async (dispatch) => {
  try {
    const res = await ApiData.getimpact();
    dispatch({
      type: GET_IMPACT,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
};
export const getgoal = () => async (dispatch) => {
  try {
    const res = await ApiData.getgoal();
    dispatch({
      type: GET_GOAL,
      payload: res.data,
    });
  } catch (err) {
    console.log(err);
  }
};

export const getoption =
  (university, knowledge, impact, goal) => async (dispatch) => {
    dispatch({
      type: GET_GOAL,
      payload: university,
    });
    dispatch({
      type: GET_GOAL,
      payload: knowledge,
    });
    dispatch({
      type: GET_GOAL,
      payload: impact,
    });
    dispatch({
      type: GET_GOAL,
      payload: goal,
    });
  };

export const getresultOne =
  (university, knowledge, impact, goal, page, Groupname, GroupId) =>
  async (dispatch) => {
    console.log(
      "api action :",
      university,
      ":",
      knowledge,
      ":",
      impact,
      ":",
      goal,
      ":",
      page,
      ":",
      Groupname,
      ":",
      GroupId
    );
    try {
      if (page === "knowledge") {
        const res = await ApiData.getknowledgeMap(
          university,
          knowledge,
          impact,
          goal
        );
        if (res.data.details) {
          if (Groupname === "องค์ความรู้เดิม") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.knowledges,
            });
          } else if (Groupname === "นวัตกรรม") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.innovations,
            });
          } else if (Groupname === "องค์ความรู้ใหม่") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.newknowledges,
            });
          } else if (parseInt(Groupname) === 2) {
            var newArray = res.data.details.innovations.filter(function (el) {
              return parseInt(el.outputId) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: newArray,
            });
          } else if (parseInt(Groupname) === 3) {
            var newArrayKn = res.data.details.newknowledges.filter(function (
              el
            ) {
              return parseInt(el.newknowledgeGroupId) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: newArrayKn,
            });
          } else if (parseInt(Groupname) === 4) {
            var newArrayNewKn = res.data.details.knowledges.filter(function (
              el
            ) {
              return parseInt(el.knowledgeGroupId) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: newArrayNewKn,
            });
          } else if (Groupname === "") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: [],
            });
          }
        }
      } else if (page === "goal") {
        const res = await ApiData.getgoalMap(
          university,
          knowledge,
          impact,
          goal
        );
        if (res.data.details) {
          if (Groupname === "RMUTI Cluster") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.cluster,
            });
          } else if (Groupname === "BCG") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.bcg,
            });
          } else if (Groupname === "10 S-Curve") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.curve,
            });
          } else if (Groupname === "SDGs") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.sdg,
            });
          } else if (parseInt(Groupname) === 2) {
            var bcg = res.data.details.bcg.filter(function (el) {
              return parseInt(el.bcg_id) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: bcg,
            });
          } else if (parseInt(Groupname) === 3) {
            var cluster = res.data.details.cluster.filter(function (el) {
              return parseInt(el.cluster_id) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: cluster,
            });
          } else if (parseInt(Groupname) === 4) {
            var curve = res.data.details.curve.filter(function (el) {
              return parseInt(el.curve_id) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: curve,
            });
          } else if (parseInt(Groupname) === 5) {
            var sdg = res.data.details.sdg.filter(function (el) {
              return parseInt(el.sdgs_id) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: sdg,
            });
          } else if (Groupname === "") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: [],
            });
          }
        }
      } else if (page === "impact") {
        const res = await ApiData.getimpactMap(
          university,
          knowledge,
          impact,
          goal
        );
        if (res.data.details) {
          if (Groupname === "เศรษฐกิจ") {
            var dataeconomy = res.data.details.economy;
            dataeconomy[0].name = "เศรษฐกิจ";
            dispatch({
              type: GET_RESULT_ONE,
              payload: dataeconomy,
            });
          } else if (Groupname === "สังคม") {
            var datasocial = res.data.details.social;
            datasocial[0].name = "สังคม";
            dispatch({
              type: GET_RESULT_ONE,
              payload: datasocial,
            });
          } else if (Groupname === "วัฒนธรรม") {
            var datacultural = res.data.details.cultural;
            datacultural[0].name = "วัฒนธรรม";
            dispatch({
              type: GET_RESULT_ONE,
              payload: datacultural,
            });
          } else if (Groupname === "สิ่งแวดล้อม") {
            var dataenvironment = res.data.details.environment;
            dataenvironment[0].name = "สิ่งแวดล้อม";
            dispatch({
              type: GET_RESULT_ONE,
              payload: dataenvironment,
            });
          } else if (parseInt(Groupname) === 2) {
            var cultural = res.data.details.cultural.filter(function (el) {
              return parseInt(el.factor_id) === parseInt(GroupId);
            });
            cultural[0].name = "วัฒนธรรม";
            dispatch({
              type: GET_RESULT_ONE,
              payload: cultural,
            });
          } else if (parseInt(Groupname) === 3) {
            var economy = res.data.details.economy.filter(function (el) {
              return parseInt(el.factor_id) === parseInt(GroupId);
            });
            economy[0].name = "เศรษฐกิจ";
            dispatch({
              type: GET_RESULT_ONE,
              payload: economy,
            });
          } else if (parseInt(Groupname) === 4) {
            var environment = res.data.details.environment.filter(function (
              el
            ) {
              return parseInt(el.factor_id) === parseInt(GroupId);
            });
            environment[0].name = "สิ่งแวดล้อม";
            dispatch({
              type: GET_RESULT_ONE,
              payload: environment,
            });
          } else if (parseInt(Groupname) === 5) {
            var social = res.data.details.social.filter(function (el) {
              return parseInt(el.factor_id) === parseInt(GroupId);
            });
            social[0].name = "สังคม";
            dispatch({
              type: GET_RESULT_ONE,
              payload: social,
            });
          } else if (Groupname === "") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: [],
            });
          }
        }
      } else if (page === "newknowledge") {
        const res = await ApiData.getnewknowledgeMap(
          university,
          knowledge,
          impact,
          goal
        );
        if (res.data.details) {
          if (Groupname === "นวัตกรรม") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.innovations,
            });
          } else if (Groupname === "องค์ความรู้ใหม่") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: res.data.details.newknowledges,
            });
          } else if (parseInt(Groupname) === 2) {
            var innovations = res.data.details.innovations.filter(function (
              el
            ) {
              return parseInt(el.outputId) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: innovations,
            });
          } else if (parseInt(Groupname) === 3) {
            var newknowledges = res.data.details.newknowledges.filter(function (
              el
            ) {
              return parseInt(el.knowledgeGroupId) === parseInt(GroupId);
            });
            dispatch({
              type: GET_RESULT_ONE,
              payload: newknowledges,
            });
          } else if (Groupname === "") {
            dispatch({
              type: GET_RESULT_ONE,
              payload: [],
            });
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

const getknowledgeChart = async (data) => {
  var datalink = [
    {
      id: "0.0",
      parent: "",
      name: "Knowledge and Innovation",
    },

    {
      id: "1.1",
      parent: "0.0",
      name: "นวัตกรรม",
      typename: "นวัตกรรม",
      color: "#8085e9",
    },
    {
      id: "1.2",
      parent: "0.0",
      name: "องค์ความรู้ใหม่",
      typename: "องค์ความรู้ใหม่",
      color: "#11ef99",
    },
    {
      id: "1.3",
      parent: "0.0",
      name: "องค์ความรู้เดิม",
      typename: "องค์ความรู้เดิม",
      color: "#fb9b40",
    },
  ];

  const result_knowledge = [
    ...data
      .reduce((r, e) => {
        let k = `${e.label}|${e.knowledgeGroupName}`;
        if (!r.has(k)) r.set(k, { ...e, count: 1 });
        else r.get(k).count++;
        return r;
      }, new Map())
      .values(),
  ];

  const result_newknowledge = [
    ...data
      .reduce((r, e) => {
        let k = `${e.label}|${e.newknowledgeGroupName}`;
        if (!r.has(k)) r.set(k, { ...e, count: 1 });
        else r.get(k).count++;
        return r;
      }, new Map())
      .values(),
  ];

  result_knowledge.forEach((kn) => {
    if (kn.label === "องค์ความรู้เดิม") {
      if (kn.knowledgeGroupName) {
        datalink.push({
          id: "4." + kn.knowledgeGroupId,
          parent: "1.3",
          typename: "องค์ความรู้เดิม",
          GroupId: kn.knowledgeGroupId,
          name: kn.knowledgeGroupName,
          value: kn.count,
        });
      }
    }
  });

  result_newknowledge.forEach((kn) => {
    if (kn.label === "องค์ความรู้ใหม่") {
      if (kn.newknowledgeGroupName) {
        datalink.push({
          id: "3." + kn.newknowledgeGroupId,
          parent: "1.2",
          typename: "องค์ความรู้ใหม่",
          GroupId: kn.newknowledgeGroupId,
          name: kn.newknowledgeGroupName,
          value: kn.count,
        });
      }
    }
  });

  data.forEach((el) => {
    if (el.label === "นวัตกรรม") {
      datalink.push({
        id: "2." + el.outputId,
        parent: "1.1",
        typename: "นวัตกรรม",
        GroupId: el.outputId,
        name: el.title,
        value: 1,
      });
    }
  });
  return datalink;
};

const getgoalChart = async (data) => {
  var datalink = [
    {
      id: "0.0",
      parent: "",
      name: "GOAL",
    },

    {
      id: "1.1",
      parent: "0.0",
      name: "BCG",
      typename: "BCG",
      color: "#8085e9",
    },
    {
      id: "1.2",
      parent: "0.0",
      name: "SDGs",
      typename: "SDGs",
      color: "#11ef99",
    },
    {
      id: "1.3",
      parent: "0.0",
      name: "10 S-Curve",
      typename: "10 S-Curve",
      color: "#fb9b40",
    },
    {
      id: "1.4",
      parent: "0.0",
      name: "RMUTI Cluster",
      typename: "RMUTI Cluster",
      color: "#fc3",
    },
  ];

  const duplicate = (data, type) => {
    const res = data.reduce((r, e) => {
      let k;
      if (type === "bcg") {
        k = `${e.bcg_id}`;
      } else if (type === "cluster") {
        k = `${e.cluster_id}`;
      } else if (type === "curve") {
        k = `${e.curve_id}`;
      } else if (type === "sdgs") {
        k = `${e.sdgs_id}`;
      }
      if (!r.has(k)) r.set(k, { ...e, count: 1 });
      else r.get(k).count++;
      return r;
    }, new Map());

    return res;
  };

  const result_bcg = duplicate(data.bcg, "bcg");
  const result_cluster = duplicate(data.cluster, "cluster");
  const result_curve = duplicate(data.curve, "curve");
  const result_sdgs = duplicate(data.sdg, "sdgs");

  var index = 1;

  result_bcg.forEach((kn) => {
    datalink.push({
      id: "2." + kn.bcg_id + "." + index,
      parent: "1.1",
      name: kn.bcg_name,
      value: kn.count,
    });
    index++;
  });

  result_cluster.forEach((kn) => {
    datalink.push({
      id: "3." + kn.cluster_id + "." + index,
      parent: "1.4",
      name: kn.cluster_name,
      value: kn.count,
    });
    index++;
  });

  result_curve.forEach((kn) => {
    datalink.push({
      id: "4." + kn.curve_id + "." + index,
      parent: "1.3",
      name: kn.curve_name,
      value: kn.count,
    });
    index++;
  });

  result_sdgs.forEach((kn) => {
    datalink.push({
      id: "5." + kn.sdgs_id + "." + index,
      parent: "1.2",
      name: kn.sdgs_name,
      value: kn.count,
    });
    index++;
  });

  return datalink;
};

const getimpactChart = async (data) => {
  var datalink = [
    {
      id: "0.0",
      parent: "",
      name: "ผลกระทบ",
    },

    {
      id: "1.1",
      parent: "0.0",
      name: "เศรษฐกิจ",
      typename: "economy",
      color: "#8085e9",
    },
    {
      id: "1.2",
      parent: "0.0",
      name: "สังคม",
      typename: "social",
      color: "#11ef99",
    },
    {
      id: "1.3",
      parent: "0.0",
      name: "วัฒนธรรม",
      typename: "cultural",
      color: "#fb9b40",
    },
    {
      id: "1.4",
      parent: "0.0",
      name: "สิ่งแวดล้อม",
      typename: "environment",
      color: "#fc3",
    },
  ];
  const duplicate = (data) => {
    const res = data.reduce((r, e) => {
      let k = `${e.factor_id}`;
      if (!r.has(k)) r.set(k, { ...e, count: 1 });
      else r.get(k).count++;
      return r;
    }, new Map());

    return res;
  };

  const result_cultural = duplicate(data.cultural);
  const result_economy = duplicate(data.economy);
  const result_environment = duplicate(data.environment);
  const result_social = duplicate(data.social);
  var index = 1;

  result_cultural.forEach((kn) => {
    datalink.push({
      id: "2." + kn.factor_id + "." + index,
      parent: "1.3",
      name: kn.factor_name,
      value: kn.count,
    });
    index++;
  });

  result_economy.forEach((kn) => {
    datalink.push({
      id: "3." + kn.factor_id + "." + index,
      parent: "1.1",
      name: kn.factor_name,
      value: kn.count,
    });
    index++;
  });

  result_environment.forEach((kn) => {
    datalink.push({
      id: "4." + kn.factor_id + "." + index,
      parent: "1.4",
      name: kn.factor_name,
      value: kn.count,
    });
    index++;
  });

  result_social.forEach((kn) => {
    datalink.push({
      id: "5." + kn.factor_id + "." + index,
      parent: "1.2",
      name: kn.factor_name,
      value: kn.count,
    });
    index++;
  });
  return datalink;
};

const getnewknowledgeChart = async (data) => {
  var datalink = [
    {
      id: "0.0",
      parent: "",
      name: "NewKnowledge and Innovation",
    },

    {
      id: "1.1",
      parent: "0.0",
      name: "นวัตกรรม",
      typename: "นวัตกรรม",
      color: "#8085e9",
    },
    {
      id: "1.2",
      parent: "0.0",
      name: "องค์ความรู้ใหม่",
      typename: "องค์ความรู้ใหม่",
      color: "#fb9b40",
    },
  ];

  const result_newknowledge = [
    ...data
      .reduce((r, e) => {
        let k = `${e.label}|${e.knowledgeGroupName}`;
        if (!r.has(k)) r.set(k, { ...e, count: 1 });
        else r.get(k).count++;
        return r;
      }, new Map())
      .values(),
  ];

  result_newknowledge.forEach((kn) => {
    if (kn.label === "องค์ความรู้ใหม่") {
      if (kn.knowledgeGroupName) {
        datalink.push({
          id: "3." + kn.knowledgeGroupId,
          parent: "1.2",
          typename: "องค์ความรู้ใหม่",
          GroupId: kn.knowledgeGroupId,
          name: kn.knowledgeGroupName,
          value: kn.count,
        });
      }
    }
  });

  data.forEach((el) => {
    if (el.label === "นวัตกรรม") {
      datalink.push({
        id: "2." + el.outputId,
        parent: "1.1",
        typename: "นวัตกรรม",
        GroupId: el.outputId,
        name: el.title,
        value: 1,
      });
    }
  });
  return datalink;
};

export const getknowledgeMap =
  (university, knowledge, impact, goal, page) => async (dispatch) => {
    try {
      if (page === "knowledge") {
        const res = await ApiData.getknowledgeMap(
          university,
          knowledge,
          impact,
          goal
        );
        dispatch({
          type: GET_KNOWLEDGE_MAP,
          payload: res.data,
        });
        if (res.data.data) {
          dispatch({
            type: GET_KNOWLEDGE_COUNT,
            payload: res.data.data,
          });
        }

        if (res.data.details.innovations) {
          dispatch({
            type: GET_INNOVATIONS_RESULT,
            payload: res.data.details.innovations,
          });
        }

        if (res.data.details.knowledges) {
          dispatch({
            type: GET_KNOWLEDGE_RESULT,
            payload: res.data.details.knowledges,
          });
        }
        if (res.data.details.newknowledges) {
          dispatch({
            type: GET_NEWKNOWLEDGE_RESULT,
            payload: res.data.details.newknowledges,
          });
        }

        dispatch({
          type: GET_RESULT_ONE,
          payload: [],
        });
        if (res.data.nodes) {
          const dataChart = await getknowledgeChart(res.data.nodes);
          dispatch({
            type: GET_KNOWLEDGE_CHART,
            payload: dataChart,
          });
        }
      } else if (page === "goal") {
        const res = await ApiData.getgoalMap(
          university,
          knowledge,
          impact,
          goal
        );
        dispatch({
          type: GET_GOAL_MAP,
          payload: res.data,
        });

        if (res.data.data) {
          dispatch({
            type: GET_GOAL_COUNT,
            payload: res.data.data,
          });
        }

        if (res.data.details.bcg) {
          dispatch({
            type: GET_BCG_RESULT,
            payload: res.data.details.bcg,
          });
        }
        if (res.data.details.sdg) {
          dispatch({
            type: GET_SDGS_RESULT,
            payload: res.data.details.sdg,
          });
        }
        if (res.data.details.curve) {
          dispatch({
            type: GET_CURVE_RESULT,
            payload: res.data.details.curve,
          });
        }
        if (res.data.details.cluster) {
          dispatch({
            type: GET_CLUSTER_RESULT,
            payload: res.data.details.cluster,
          });
        }

        dispatch({
          type: GET_RESULT_ONE,
          payload: [],
        });

        if (res.data.details) {
          const dataChart = await getgoalChart(res.data.details);
          dispatch({
            type: GET_GOAL_CHART,
            payload: dataChart,
          });
        }
      } else if (page === "impact") {
        const res = await ApiData.getimpactMap(
          university,
          knowledge,
          impact,
          goal
        );
        dispatch({
          type: GET_IMPACT_MAP,
          payload: res.data,
        });

        if (res.data.data) {
          dispatch({
            type: GET_IMPACT_COUNT,
            payload: res.data.data,
          });
        }

        if (res.data.details.economy) {
          dispatch({
            type: GET_ECONOMY_RESULT,
            payload: res.data.details.economy,
          });
        }
        if (res.data.details.social) {
          dispatch({
            type: GET_SOCIETY_RESULT,
            payload: res.data.details.social,
          });
        }
        if (res.data.details.cultural) {
          dispatch({
            type: GET_CULTURE_RESULT,
            payload: res.data.details.cultural,
          });
        }
        if (res.data.details.environment) {
          dispatch({
            type: GET_ENVIRONMENT_RESULT,
            payload: res.data.details.environment,
          });
        }

        dispatch({
          type: GET_RESULT_ONE,
          payload: [],
        });

        if (res.data.details) {
          const dataChart = await getimpactChart(res.data.details);
          dispatch({
            type: GET_IMPACT_CHART,
            payload: dataChart,
          });
        }
      } else if (page === "newknowledge") {
        const res = await ApiData.getnewknowledgeMap(
          university,
          knowledge,
          impact,
          goal
        );
        dispatch({
          type: GET_NEWKNOWLEDGE_MAP,
          payload: res.data,
        });

        if (res.data.data) {
          dispatch({
            type: GET_NEWKNOWLEDGE_COUNT,
            payload: res.data.data,
          });
        }

        if (res.data.details.innovations) {
          dispatch({
            type: GET_INNOVATIONS_RESULT,
            payload: res.data.details.innovations,
          });
        }
        if (res.data.details.newknowledges) {
          dispatch({
            type: GET_NEWKNOWLEDGE_RESULT,
            payload: res.data.details.newknowledges,
          });
        }

        dispatch({
          type: GET_RESULT_ONE,
          payload: [],
        });

        if (res.data.nodes) {
          const dataChart = await getnewknowledgeChart(res.data.nodes);
          dispatch({
            type: GET_NEWKNOWLEDGE_CHART,
            payload: dataChart,
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
